<div
  class="border-b border-primary bg-white p-5 z-20 flex justify-between items-center"
>
  <img src="assets/images/new-images/logo-2.png" class="w-[6rem] h-[2rem]" />

  <h2 class="font-semibold text-xl text-center">{{ title }}</h2>

  <div class="flex gap-4">
    <h3 *ngIf="subtitle" class="border-2 border-gray-300 p-2 rounded-lg">
      {{ subtitle }}
    </h3>
    <ng-container *ngIf="showCloseBtn">
      <mat-icon
        *ngIf="!confirmBeforeClose"
        mat-dialog-close
        class="text-red-500 text-3xl cursor-pointer"
        (click)="dismiss()"
        >highlight_off</mat-icon
      >
      <!-- No mat-dialog-close: the host closes it only once confirmed. -->
      <mat-icon
        *ngIf="confirmBeforeClose"
        class="text-red-500 text-3xl cursor-pointer"
        (click)="dismiss()"
        >highlight_off</mat-icon
      >
    </ng-container>
  </div>
</div>
